'use client';

import { useTranslation } from 'react-i18next';

import { Badge } from '@kit/ui/badge';
import { Input } from '@kit/ui/input';

import type { MeasurementFieldProps } from '../types';
import { getUnitLabel } from './unit-toggle-button';

/**
 * Single value input field with unit badge
 */
export function MeasurementInputField({
  value,
  onChange,
  placeholder,
  label,
  unit,
  measurementType,
  min,
  max,
}: MeasurementFieldProps) {
  const { t } = useTranslation();
  return (
    <div className="relative">
      <Input
        type="number"
        placeholder={
          placeholder ||
          t('dancer:measurement.enterField', { field: label.toLowerCase() })
        }
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        min={min}
        max={max}
        aria-label={label}
      />
      <Badge
        variant="secondary"
        className="absolute top-1/2 right-2 -translate-y-1/2 text-xs"
      >
        {getUnitLabel(measurementType, unit)}
      </Badge>
    </div>
  );
}
